module.exports = __webpack_public_path__ + "img/logo_ddc.bf0ff7f1.svg";